import coreAPIInstance from "./coreApiInstance";

export const highlightConfigAPIs = {
  createHighlightConfig: ({ payload }) => coreAPIInstance.post(`/api/v1/highlight-config`, payload),
  deleteHighlightConfig: ({ headers, highlightConfigId }) =>
    coreAPIInstance.delete(`/api/v1/highlight-config/${highlightConfigId}`, { headers }),
  getHighlightConfigs: ({ entityId, headers, payload }) =>
    coreAPIInstance.get(`/api/v1/highlight-config/${entityId}`, {
      headers,
      params: { ...payload },
    }),
  createHighlightType: ({ payload, headers }) =>
    coreAPIInstance.post(`/api/v1/highlight-config/highlight-type`, payload, { headers }),
  getHighlightTypes: ({ entityId, highlightConfigId, headers, payload }) =>
    coreAPIInstance.get(`/api/v1/highlight-config/highlight-type`, {
      headers,
      params: {
        entityId,
        page: 1,
        pageSize: 100,
        category: payload.category,
        highlightConfigId,
        tournamentId: payload.tournamentId,
      },
    }),
  updateHighlightType: ({ highlightTypeId, headers, payload }) =>
    coreAPIInstance.patch(`/api/v1/highlight-config/highlight-type/${highlightTypeId}`, payload, { headers }),
  deleteHighlightType: ({ headers, highlightTypeId }) =>
    coreAPIInstance.delete(`/api/v1/highlight-config/highlight-type/${highlightTypeId}`, { headers }),
};
